'use client';

import * as React from 'react';
import { cn } from '../../lib/utils';

const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
    ({ className, ...props }, ref) => (
        <label
            ref={ref}
            className={cn(
                // DS3's outside field label: Kalshi Sans medium, 13px.
                'font-kalshi-sans text-[13px] font-medium leading-[18px] text-text-x10 peer-disabled:cursor-not-allowed peer-disabled:opacity-30',
                className,
            )}
            {...props}
        />
    ),
);
Label.displayName = 'Label';

export { Label };
